var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellnessliving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "22.978%",
    x2: "69.273%",
    y1: "73.904%",
    y2: "3.955%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBB041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "92%",
    stopColor: "#FFDA15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDE11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: ".02%",
    x2: "99.996%",
    y1: "49.943%",
    y2: "49.943%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D48C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "18%",
    stopColor: "#D79737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "69%",
    stopColor: "#DDB02A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DFBA25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__c",
    x1: "0%",
    x2: "99.972%",
    y1: "50.009%",
    y2: "50.009%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#73784B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "8%",
    stopColor: "#777B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A3993F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__d",
    x1: "-.019%",
    x2: "100.002%",
    y1: "50.002%",
    y2: "50.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3DB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "4%",
    stopColor: "#41B64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "46%",
    stopColor: "#6BBF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#84C442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8EC641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__e",
    x1: "-.015%",
    x2: "99.999%",
    y1: "49.963%",
    y2: "49.963%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#673090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#8C2B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "58%",
    stopColor: "#B6246D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "84%",
    stopColor: "#CF2061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D91F5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__f",
    x1: "0%",
    x2: "99.956%",
    y1: "50.005%",
    y2: "50.005%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EC76AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9%",
    stopColor: "#EB6CA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49%",
    stopColor: "#E64284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81%",
    stopColor: "#E3296F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E21F67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__g",
    x1: "-.001%",
    x2: "99.995%",
    y1: "49.99%",
    y2: "49.99%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#29AAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "33%",
    stopColor: "#2973AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63%",
    stopColor: "#284883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86%",
    stopColor: "#282F6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#282561"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__h",
    x1: ".029%",
    x2: "99.999%",
    y1: "49.965%",
    y2: "49.965%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#29AAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "23%",
    stopColor: "#2AAEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "57%",
    stopColor: "#2CB297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "84%",
    stopColor: "#2DB57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2DB674"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    fillRule: "nonzero",
    d: "M35.145 4.202c0 4.885-3.812 9.25-6.872 11.967h-.012c-1.16.425-2.149 1.217-2.817 2.255-.054.042-.108.084-.155.115-.915-1.506-2.481-2.498-4.234-2.682-.266-.032-.535-.049-.803-.05h-.233c-2.871-2.539-6.07-6.493-6.126-11.484-.007-1.036.377-2.036 1.074-2.801C15.781.587 16.95.035 18.19 0c2.623 0 6.38 2.568 6.38 2.568s3.167-2.48 6.339-2.48c1.301-.01 2.54.556 3.385 1.546.576.73.877 1.638.852 2.568z",
    style: {
      mixBlendMode: "darken"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    fillRule: "nonzero",
    d: "M21.055 15.857c-.266-.032-.535-.049-.803-.05h-.233c-1.868.101-4.323 1.401-5.322 3.782-.278.667-.428 1.38-.444 2.101-3.735.12-8.403-.549-11.744-3.826-.666-.66-1.086-1.527-1.192-2.458-.177-1.323.252-2.655 1.167-3.627 1.867-1.854 6.32-2.706 6.32-2.706s.498-3.987 2.737-6.225c.9-.913 2.151-1.391 3.431-1.312.94.094 1.816.524 2.465 1.211 3.399 3.385 3.83 9.039 3.618 13.11z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    fillRule: "nonzero",
    d: "M16.807 28.203c-.026.036-.054.071-.084.105-2.463 3.086-6.77 7.143-12.388 7.196-.996.01-1.962-.343-2.717-.992C.63 33.7.04 32.5 0 31.221c0-2.622 2.568-6.387 2.568-6.387S.096 21.67.096 18.501c-.002-1.149.435-2.256 1.22-3.095.762-.765 1.807-1.18 2.886-1.146 4.087 0 7.81 2.67 10.504 5.336-.277.667-.428 1.38-.444 2.101v.196c-.007 2.512.95 4.484 2.545 6.31z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    fillRule: "nonzero",
    d: "M17.96 46.793c-.77.775-1.814 1.217-2.906 1.23-1.182.044-2.332-.388-3.191-1.2-1.868-1.867-2.701-6.321-2.701-6.321s-3.987-.497-6.225-2.736c-.87-.857-1.348-2.034-1.324-3.254.048-1.008.487-1.957 1.223-2.647 3.616-3.609 9.783-3.87 13.882-3.557l.196.018c.982 1.083 2.047 2.088 3.184 3.007.544.45 1.039.903 1.499 1.354.012.058.02.118.025.177.448 3.922.294 9.883-3.662 13.929z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__e)",
    fillRule: "nonzero",
    d: "M48.028 14.94c.013 1.133-.434 2.223-1.24 3.02-2.96 2.899-6.947 3.749-10.408 3.826-.005-1.142-.351-2.257-.995-3.2-1.246-1.826-3.396-2.778-4.998-2.778-.72-.006-1.436.114-2.114.354h-.012c-.233-4.087.147-9.871 3.604-13.326.643-.673 1.503-1.098 2.428-1.202 1.292-.09 2.56.389 3.468 1.312 2.244 2.238 2.734 6.225 2.734 6.225s4.472.845 6.328 2.701c.782.829 1.214 1.928 1.205 3.067z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__f)",
    fillRule: "nonzero",
    d: "M33.359 28.728c2.535 2.936 6.583 6.344 11.739 6.405 1.035.008 2.035-.375 2.801-1.071.942-.81 1.5-1.978 1.536-3.22 0-2.62-2.568-6.379-2.568-6.379s2.468-3.172 2.468-6.34c.006-1.193-.465-2.339-1.307-3.184-.755-.713-1.764-1.094-2.802-1.057-3.762 0-7.22 2.264-9.848 4.703.644.944.99 2.059.995 3.2.002.033.002.065 0 .096 0 2.535-.97 4.496-2.568 6.345l-.446.502z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__g)",
    fillRule: "nonzero",
    d: "M33.814 28.226c4.048-.194 9.559.285 12.897 3.62.621.593 1.035 1.37 1.181 2.216.234 1.43-.42 2.82-1.281 3.68-2.239 2.24-6.228 2.737-6.228 2.737s-.845 4.472-2.706 6.325c-.897.847-2.107 1.28-3.338 1.196-1.04-.05-2.022-.488-2.752-1.23-3.608-3.682-4.059-8.955-3.77-12.825.234-.255.481-.52.745-.787.629-.641 1.29-1.25 1.98-1.825.99-.81 1.932-1.68 2.817-2.605l.455-.502z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__h)",
    fillRule: "nonzero",
    d: "M35.369 45.233c.008 1.018-.358 2.002-1.03 2.767-.812.961-1.995 1.532-3.254 1.57-2.628 0-6.386-2.567-6.386-2.567s-3.165 2.483-6.333 2.483c-1.26.012-2.467-.516-3.312-1.451-.629-.737-.961-1.68-.934-2.648 0-5.228 4.365-9.86 7.498-12.511.028-.026.057-.05.088-.073 1.371 1.313 2.582 2.783 3.61 4.38.731-1.15 1.567-2.23 2.497-3.226.233-.255.48-.521.744-.787 3.03 2.493 6.758 6.676 6.812 12.063z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9ED32",
    fillRule: "nonzero",
    d: "M28.273 16.162h-.012s.007-.004.012 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.814 28.226c-.142.166-.294.336-.467.502"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellnessliving);
export default __webpack_public_path__ + "static/media/wellnessliving.bf68f54e899121e7a2e7265cce8f42b2.svg";
export { ForwardRef as ReactComponent };